import React from "react";

import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";

import { getStep } from "../helper";
import { numberWithUnit } from "../../helper";
import { createRange } from "../helper";

interface IInputNumericValueSelect {
  disabled?: boolean;
  disabledInput?: boolean;
  max: number;
  min: number;
  onChangeHandler: any;
  prefix?: string;
  step?: number;
  suffix?: string;
  unit?: string;
  value: number;
}

const InputNumericValueSelect: React.FC<IInputNumericValueSelect> = ({
  disabled = false,
  max = 100,
  min = 0,
  onChangeHandler = (e: any) => e,
  prefix,
  step,
  suffix,
  unit,
  value = 30,
}) => {
  if (min >= max) {
    return null;
  }

  const handleChange = (event: SelectChangeEvent) => {
    onChangeHandler(parseInt(event.target.value));
  };

  let options: number[] = createRange({
    min,
    max,
    step: step || getStep(max - min),
  });

  return (
    <FormControl
      fullWidth
      disabled={disabled}
      data-testid="input-numeric-value-select"
    >
      {JSON.stringify(options)}
      <Select value={value.toString()} onChange={handleChange}>
        {options.map((option: number) => (
          <MenuItem value={option.toString()}>
            {numberWithUnit({ value: option, unit })}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default InputNumericValueSelect;
